// ©2024 Austin App House. All rights reserved.
import React from 'react';

const InfoMessage = ({ header, contentArray = [], click = {} }) => (
  <div className="wurqly-toast-rich">
    {header && <div className="wurqly-toast-card__title">{header}</div>}
    {contentArray.length > 0 && (
      <ul className="wurqly-toast-rich__list">
        {contentArray.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    )}
    {click.label && (
      <button
        type="button"
        className="dashboard-btn dashboard-btn--secondary wurqly-toast-rich__action"
        onClick={click.onClick}
      >
        {click.label}
      </button>
    )}
  </div>
);

export default InfoMessage;
